import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Table from './components/Table';
import Form from './components/Form';
import API from '../../services/API';
import Icon from "../../components/Icon";

class AdkBannerDefaultOffersCpc extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            isShowForm: false,
            cpcToUpdate: null,
            cpc: []
        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleRemoveBtnClick = this.handleRemoveBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleSync = this.handleSync.bind(this);
    }

    componentDidMount() {
        this.loadCpc();
    }

    loadCpc() {
        this.setState({ isLoading: true });

        API.AdkBanner.DefaultOffersCpc.get().then(cpc => this.setState({ cpc, isLoading: false }));
    }

    handleAddBtnClick() {
        this.setState({ isShowForm: true });
    }

    handleFormHide() {
        this.setState({ isShowForm: false, cpcToUpdate: null });
    }

    handleFormSubmit(country, cpc) {
        this.setState({
            isShowForm: false,
            isLoading: true,
            cpcToUpdate: null
        });

        API.AdkBanner.DefaultOffersCpc.save(country, cpc).then(() => this.loadCpc());
    }

    handleRemoveBtnClick(country) {
        this.setState({ isLoading: true });

        API.AdkBanner.DefaultOffersCpc.remove(country).then(() => this.loadCpc());
    }

    handleSync() {
        this.setState({ isLoading: true });

        API.Sync(['adk-banner-EU'], 'defaultOffersCpc', 8083)
            .then(() => this.setState({ isLoading: false }));
    }

    getForm() {
        if(this.state.isShowForm) {
            return <Form
                onSubmit={this.handleFormSubmit}
                onFormHide={this.handleFormHide}
                cpc={this.state.cpcToUpdate}/>;
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Default Offers Cpc"/>
                <Row>
                    <Col lg={12}>
                        <div className="pull-right m-b-15">
                            <Button bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                            <Button bsStyle="info" onClick={this.handleSync}> Sync</Button>
                        </div>
                    </Col>
                </Row>

                {this.getForm()}

                <Table cpc={this.state.cpc} onRemove={this.handleRemoveBtnClick} onUpdate={this.handleUpdateBtnClick}/>
            </Container>
        );
    }
}

export default AdkBannerDefaultOffersCpc;


// WEBPACK FOOTER //
// ./src/scenes/AdkBannerDefaultOffersCpc/index.js